import { isPatrolmanPlusSku, isReconSku } from "../configuration-sku-family.js";

/** FI-3C die-cut carton stocked at Pack Out via manufacturing.station_stock (not warehouse kitting). */
export const PREPACK_FI3C_PHYSICAL_BOX_SKU = "88-406-24";

/** FI-5A-W communicating-product carton stocked at Pack Out via manufacturing.station_stock. */
export const PREPACK_FI5AW_PHYSICAL_BOX_SKU = "88-406-W-24";

const PREPACK_PHYSICAL_BOX_SKU_SET_LOWER = new Set(
  [PREPACK_FI3C_PHYSICAL_BOX_SKU, PREPACK_FI5AW_PHYSICAL_BOX_SKU].map((sku) => sku.toLowerCase()),
);

/** Map a finished device SKU to the physical box carton consumed at pre-pack box pairing. */
export function resolvePrepackPhysicalBoxSku(finishedSkuRaw: string): string | null {
  const finishedSku = finishedSkuRaw.trim();
  if (finishedSku === "") return null;
  if (isPatrolmanPlusSku(finishedSku)) return PREPACK_FI5AW_PHYSICAL_BOX_SKU;
  if (isReconSku(finishedSku)) return PREPACK_FI3C_PHYSICAL_BOX_SKU;
  return null;
}

/** True for station_stock prepack carton SKUs excluded from kitting pick routes. */
export function isPrepackPhysicalBoxStationStockSku(skuRaw: string): boolean {
  const sku = skuRaw.trim().toLowerCase();
  return PREPACK_PHYSICAL_BOX_SKU_SET_LOWER.has(sku);
}
